 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-02157682":"ceb1534d"}[chunkId] + ".js"
 	}

 	// object to store loaded and loading wasm modules
 	var installedWasmModules = {};

 	function promiseResolve() { return Promise.resolve(); }

 	var wasmImportObjects = {
 		"ec67": function() {
 			return {
 				"./csv2sql": {
 					"__wbg_log_03472dbc351a4f29": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_log_03472dbc351a4f29"](p0i32,p1i32);
 					},
 					"__wbg_alert_2d30aae8e03ae5fd": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_alert_2d30aae8e03ae5fd"](p0i32,p1i32);
 					},
 					"__wbindgen_json_serialize": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbindgen_json_serialize"](p0i32,p1i32);
 					},
 					"__wbindgen_string_new": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbindgen_string_new"](p0i32,p1i32);
 					},
 					"__wbindgen_object_drop_ref": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbindgen_object_drop_ref"](p0i32);
 					},
 					"__wbindgen_json_parse": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbindgen_json_parse"](p0i32,p1i32);
 					},
 					"__wbindgen_string_get": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbindgen_string_get"](p0i32,p1i32);
 					},
 					"__wbindgen_object_clone_ref": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbindgen_object_clone_ref"](p0i32);
 					},
 					"__wbindgen_throw": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbindgen_throw"](p0i32,p1i32);
 					},
 					"__wbindgen_cb_drop": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbindgen_cb_drop"](p0i32);
 					},
 					"__wbg_call_720151a19a4c6808": function(p0i32,p1i32,p2i32) {
 						return installedModules["d1dd"].exports["__wbg_call_720151a19a4c6808"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_newnoargs_a6ad1b52f5989ea9": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_newnoargs_a6ad1b52f5989ea9"](p0i32,p1i32);
 					},
 					"__wbg_forEach_7796ea23499aa552": function(p0i32,p1i32,p2i32) {
 						return installedModules["d1dd"].exports["__wbg_forEach_7796ea23499aa552"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_message_0ff90cbb5270c176": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbg_message_0ff90cbb5270c176"](p0i32);
 					},
 					"__wbg_name_dddf7a57ae3f9867": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbg_name_dddf7a57ae3f9867"](p0i32);
 					},
 					"__wbg_apply_823defaa2a295bb4": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules["d1dd"].exports["__wbg_apply_823defaa2a295bb4"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_call_7aced47e67a8c62d": function(p0i32,p1i32,p2i32,p3i32) {
 						return installedModules["d1dd"].exports["__wbg_call_7aced47e67a8c62d"](p0i32,p1i32,p2i32,p3i32);
 					},
 					"__wbg_new_bdd94b8735e4f66d": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_new_bdd94b8735e4f66d"](p0i32,p1i32);
 					},
 					"__wbg_resolve_b2d9398056dbfe64": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbg_resolve_b2d9398056dbfe64"](p0i32);
 					},
 					"__wbg_then_c75e723ffb976395": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_then_c75e723ffb976395"](p0i32,p1i32);
 					},
 					"__wbg_error_cc95a3d302735ca3": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_error_cc95a3d302735ca3"](p0i32,p1i32);
 					},
 					"__wbindgen_number_new": function(p0f64) {
 						return installedModules["d1dd"].exports["__wbindgen_number_new"](p0f64);
 					},
 					"__wbg_log_74d904c418cf24db": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_log_74d904c418cf24db"](p0i32,p1i32);
 					},
 					"__wbg_String_5380427aff8fe7c7": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_String_5380427aff8fe7c7"](p0i32,p1i32);
 					},
 					"__wbg_self_1ec1c3e6d75f31d7": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbg_self_1ec1c3e6d75f31d7"](p0i32);
 					},
 					"__wbindgen_jsval_eq": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbindgen_jsval_eq"](p0i32,p1i32);
 					},
 					"__wbg_static_accessor_document_b0c76025fc904ba5": function() {
 						return installedModules["d1dd"].exports["__wbg_static_accessor_document_b0c76025fc904ba5"]();
 					},
 					"__wbg_getElementById_b568d9288b16b48f": function(p0i32,p1i32,p2i32) {
 						return installedModules["d1dd"].exports["__wbg_getElementById_b568d9288b16b48f"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_setinnerhtml_bc8921a1ce6b1b82": function(p0i32,p1i32,p2i32) {
 						return installedModules["d1dd"].exports["__wbg_setinnerhtml_bc8921a1ce6b1b82"](p0i32,p1i32,p2i32);
 					},
 					"__wbg_innerhtml_12e39d90d691cea1": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_innerhtml_12e39d90d691cea1"](p0i32,p1i32);
 					},
 					"__wbg_stack_a8569ef64277dd4e": function(p0i32) {
 						return installedModules["d1dd"].exports["__wbg_stack_a8569ef64277dd4e"](p0i32);
 					},
 					"__wbg_stack_27fca1c99e84b66f": function(p0i32,p1i32) {
 						return installedModules["d1dd"].exports["__wbg_stack_27fca1c99e84b66f"](p0i32,p1i32);
 					},
 					"__wbindgen_closure_wrapper584": function(p0i32,p1i32,p2i32) {
 						return installedModules["d1dd"].exports["__wbindgen_closure_wrapper584"](p0i32,p1i32,p2i32);
 					}
 				}
 			};
 		},
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// Fetch + compile chunk loading for webassembly

 		var wasmModules = {"chunk-02157682":["ec67"]}[chunkId] || [];

 		wasmModules.forEach(function(wasmModuleId) {
 			var installedWasmModuleData = installedWasmModules[wasmModuleId];

 			// a Promise means "currently loading" or "already loaded".
 			if(installedWasmModuleData)
 				promises.push(installedWasmModuleData);
 			else {
 				var importObject = wasmImportObjects[wasmModuleId]();
 				var req = fetch(__webpack_require__.p + "" + {"ec67":"3ed94fb92c8d6a95e409"}[wasmModuleId] + ".module.wasm");
 				var promise;
 				if(importObject instanceof Promise && typeof WebAssembly.compileStreaming === 'function') {
 					promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
 						return WebAssembly.instantiate(items[0], items[1]);
 					});
 				} else if(typeof WebAssembly.instantiateStreaming === 'function') {
 					promise = WebAssembly.instantiateStreaming(req, importObject);
 				} else {
 					var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
 					promise = bytesPromise.then(function(bytes) {
 						return WebAssembly.instantiate(bytes, importObject);
 					});
 				}
 				promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
 					return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
 				}));
 			}
 		});
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sqltise/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// object with all WebAssembly.instance exports
 	__webpack_require__.w = {};

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
